import { render } from "./DataGridItem.vue?vue&type=template&id=f8a9f448"
import script from "./DataGridItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DataGridItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Landingpage/DataGridItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8a9f448"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8a9f448', __exports__)) {
    api.reload('f8a9f448', __exports__)
  }
  
  module.hot.accept("./DataGridItem.vue?vue&type=template&id=f8a9f448", () => {
    api.rerender('f8a9f448', render)
  })

}


export default __exports__